import React from 'react'

function Icon() {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#202020" fill-opacity="0.5" d="M8 14.666A6.666 6.666 0 118 1.333a6.666 6.666 0 010 13.333zm0-1.333A5.333 5.333 0 108 2.666a5.333 5.333 0 000 10.667zm-.666-8.667h1.333V6H7.334V4.666zm0 2.667h1.333v4H7.334v-4z"></path>
</svg>
  )
}

export default Icon
